import { useRouter } from 'next/router';
import React, { useEffect, useReducer } from 'react';

export const initialState = {
  additionalType: '',
  text: '',
  town: '',
  priceMin: '',
  priceMax: '',
  category: '',
  subInfos: {},
  page: 1,
  limit: 8,
};

function reducer(state, action) {
  switch (action.type) {
    case 'RESET':
      return initialState;
    case 'UPDATE':
      return { ...state, ...action.payload };
    default:
      return state;
  }
}
export const SearchContext = React.createContext({});

export const SearchProvider = ({ children }) => {
  const router = useRouter();

  const { query } = router;
  const { category: queryCategory } = query;

  const initialSearch = {
    ...initialState,
    ...query,
    category: queryCategory === 'all' ? '' : queryCategory,
  };

  const [state, dispatch] = useReducer(reducer, initialSearch);

  return (
    <SearchContext.Provider value={{ state, dispatch }}>
      {children}
    </SearchContext.Provider>
  );
};
